import type { SVGProps } from 'react';

const SvgShareMd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <circle cx={6} cy={12} r={3} stroke='currentColor' strokeWidth={1.5} />
    <circle cx={18} cy={6} r={3} stroke='currentColor' strokeWidth={1.5} />
    <circle cx={18} cy={18} r={3} stroke='currentColor' strokeWidth={1.5} />
    <path d='M8.5 10L15 7' stroke='currentColor' strokeWidth={1.5} strokeLinecap='round' strokeLinejoin='round' />
    <path d='M9 14L15 17' stroke='currentColor' strokeWidth={1.5} strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
export default SvgShareMd;
